<template>
  <a-form :form="form">
    <a-row :gutter="16">
      <a-col :xs="{span: 24}" :lg="{span:8}">
        <a-form-item  label="Termin">
          <a-select
            showSearch
            :not-found-content="null"
            option-filter-prop="children"
            v-decorator="[
              'termin',
              {
                rules: [{ required: true }],
                initialValue: null,
              },
            ]"
            
          >
            <a-select-option v-if="getterminlistsalesContract==undefined" disabled key=""></a-select-option>
            <a-select-option
              v-else
              v-for="item in getterminlistsalesContract"
              :key="item.id_sc_dtl_invoice"
              >{{item.work_nm}} | {{ formatCurrency("IDR",item.nilai_termin) }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="Value">
          <a-input-number
            type="number"
            :min="0"
            
            class="m-width-full m-text-align-right"
            :formatter="value => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
            :parser="value => value.replace(/\\s?|(,*)/g, '')"
            v-decorator="['value', {rules: [{required: true}]}]"
          />
        </a-form-item>
        <!-- @change="convertinghrg" -->
        <a-form-item label="Remark">
          <a-input autocomplete="off" v-decorator="['remark', {rules: [{required: true}]}]"></a-input>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button @click="handleNewItem" block type="primary" html-type="submit">Add</a-button>
        </a-form-item>
      </a-col>
      <a-col :xs="{span: 24}" :lg="{span:16}">
        <a-collapse class="margin-top" activeKey="1">

          <a-collapse-panel key="1">
            <h4 slot="header" class="margin-remove">Invoice Details</h4>
            <a-table v-if="!getScreen" :columns="columns" :dataSource="getCountWeb" :pagination="pagination" size="small" :scroll="{ x: 700}" bordered>
              <template slot="termin" slot-scope="item">
                <span>{{item.termin_description}}</span>
              </template>
              <template slot="value" slot-scope="val">
                <span>{{formatCurrency(val.currency,val.value)}}</span>
              </template>
              <template slot="operation" slot-scope="index,item">
                <a-button-group v-if="item">
                  <a-button type="primary" @click="handleEditModal(item)">
                    <a-icon type="edit"/>
                  </a-button>
                  <a-button type="danger" @click="handleRemove(item)">
                    <a-icon type="close"/>
                  </a-button>
                </a-button-group>
              </template>
            </a-table>

            <a-list itemLayout="vertical" :dataSource="collectData.detilTermin" :pagination="pagination" v-else>
              <!-- <Empty v-if="collectData ? collectData.detilTermin.length<=0 : collectData.detilTermin"/> -->
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <a-row slot="title" type="flex" justify="space-between">
                    <a href="#">{{item.deskripsi}}</a>
                  </a-row>
                  <p slot="description">
                  <ul class="m-list-wrapper">
                  <h3 class="margin-remove" >{{item.values.nama_barang}}</h3>
                    <div class="m-display-flex space-between">
                      <span>{{item.values.jumlah}}&nbsp;{{item.values.satuan}}</span>
                      <div>
                        <h4
                                class="margin-remove m-text-align right"
                        >@ {{formatCurrency("IDR",item.values.harga)}}</h4>
                      </div>
                    </div>
                    <a-divider class="margin-small" />
                    <h4 class="margin-remove m-text-align right">{{formatCurrency("IDR",item.hargaTotal)}}</h4>
                  </ul>
                  </p>
                </a-list-item-meta>

                <a-button-group>
                  <a-button type="primary" @click="handleEditModal(item)"
                    >
                    <a-icon type="edit" />&nbsp;Edit
                  </a-button>
                  <a-button type="danger" @click="handleRemove(item)">
                    <a-icon type="close" />&nbsp; Remove
                  </a-button>
                </a-button-group>
              </a-list-item>
            </a-list>

          </a-collapse-panel>
        </a-collapse>
        <div class="m-price-total">
          <a-statistic title="Grand Total" :value="formatCurrency('IDR',totalPrice)" class="m-text-align right" />
        </div>
      </a-col>
    </a-row>
    <a-modal v-model="editModal" :maskClosable="false" @cancel="handleClose" @ok="handleEditModal" :footer="null">
      <span slot="title">
        <a-icon type="reload" />&nbsp;Change
      </span>

      <a-form :form="modalForm">
        <a-form-item  label="Termin">
          <a-select
              showSearch
              :not-found-content="null"
              option-filter-prop="children"
              v-decorator="[
                'termin',
                {
                  rules: [{ required: true }],
                  initialValue: editData.termin,
                },
              ]"
              
            >
            
              <a-select-option
                v-for="item in getterminlistsalesContract"
                :key="item.id_sc_dtl_invoice"
                >{{item.work_nm}} | {{ formatCurrency("IDR",item.nilai_termin) }}</a-select-option
              >
            </a-select>
          </a-form-item>
        <a-form-item label="Value">
          <a-input-number
            type="number"
            :min="0"
            
            class="m-width-full m-text-align-right"
            :formatter="value => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
            :parser="value => value.replace(/\\s?|(,*)/g, '')"
            v-decorator="['value', {rules: [{required: true}],initialValue: editData.value,}]"
          />
        </a-form-item>
        <a-form-item label="Remark">
          <a-input autocomplete="off" v-decorator="['remark', {rules: [{required: true}],initialValue: editData.remark,}]"></a-input>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button @click="handleModalEdit" block type="danger" html-type="submit">Change</a-button>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-form>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  name: "DetailTermin",
  mixins: [CurrencyFormat],
  props: ["collectData","mode","id"],
  data() {
    return {
      editModal: false,
      pagination: {
        onChange: () => {},
        pageSize: 5,
        size: "small",
      },
      satuan: [],
      editData: [],
      convert_value: 0,
      modalconvert_value: 0,
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.modalForm = this.$form.createForm(this);
  },
  created() {
    this.getTreeTermin();
  },
  computed: {
    ...mapGetters(["getScreen", "getSatuan", "getAuth","getterminlistsalesContract"]),
    totalPrice() {
      let total = 0;
      this.collectData.detilTermin.forEach((item) => {
        total += Number(item.value);
      });

      return total;
    },
    columns() {
      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: 60,
          sorter: (a, b) => a.no - b.no,
          fixed: "left",
        },
        {
          title: "Termin",
          //dataIndex: "item_name",
          scopedSlots: { customRender: "termin" },
          width: 200,
          key: "termin",
          sorter: (a, b) => a.termin_description - b.termin_description,
        },
        {
          title: "Value",
          //dataIndex: "value",
          scopedSlots: { customRender: "value" },
          key: "value",
          width: 200,
          sorter: (a, b) => a.value - b.value
        },
        {
          title: "Remark",
          dataIndex: "remark",
          key: "remark",
          width: 200,
        },
        {
          title: "Action",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          width: 110,
          fixed: "right",
        },
      ];
      return kolom;
    },
    getCountWeb() {
      let data = this.collectData.detilTermin ? this.collectData.detilTermin : [];
      if (data) {
        data.forEach((value, index) => {
          data[index]["no"] = index + 1;
          data[index]["key"] = index + 1;
        });
      }
      return data;
    },
  },
  methods: {
    handleClose() {
      let idx = _.findIndex(this.getterminlistsalesContract, (e) => { 
            return e.id_sc_dtl_invoice == this.editData.termin; 
        }, 0); 
        this.getterminlistsalesContract[idx].nilai_termin = Number(this.getterminlistsalesContract[idx].nilai_termin) - Number(this.editData.value); 
      this.modalForm.resetFields();

    },
    getTreeTermin() {
      let pSalesContractId = this.collectData.informasi.sales_contract;
      let id_termin_release = this.id;
      this.$store
      .dispatch("getListTerminsalesContract", {
        sales_contract: pSalesContractId,
        id_termin_release: id_termin_release
      })
      .then(() => {
        if(this.collectData.detilTermin){
          this.collectData.detilTermin.forEach(element => {
            let index = _.findIndex(this.getterminlistsalesContract, (e) => {
                return e.id_sc_dtl_invoice === element.termin
            }, 0); 
            this.getterminlistsalesContract[index].nilai_termin = 
              Number(this.getterminlistsalesContract[index].nilai_termin)-Number(element.value);
          });
        }
      });
    },
    handleRef() {
      if (this.collectData.detilTermin.length<=0) {
        this.displayMessage("form-moreData");
      } else {
          Event.$emit("terminReleaseData", true );
      }
    },
    // handleNewItemConfirm() {
    //   this.confirmMessageValue("confirm-add-detil", true);
    // },
    handleNewItem() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        
        if(values.value==0){
          this.displayMessageValue(
            "error-other",
            "Value Must Be Grather Than 0 !")
          return;
        }

        let idx = _.findIndex(this.getterminlistsalesContract, (e) => { 
            return e.id_sc_dtl_invoice == values.termin; 
        }, 0); 

        
        if ((this.getterminlistsalesContract[idx].nilai_termin-values.value)<0){
          this.displayMessageValue(
            "error-other",
            "Termin Value is not enough!")
        } else {
          values.termin_description = this.getterminlistsalesContract[idx].work_nm;
          values.currency = "IDR";
          Event.$emit("updateListTerminSalesContract", { values, action:"add" });
          this.getterminlistsalesContract[idx].nilai_termin = 
            this.getterminlistsalesContract[idx].nilai_termin-values.value;
          this.form.resetFields();
        }
      });
    },
    // handleRemoveConfirm(item) {
    //   this.confirmMessageValue("confirm-delete-detil", item);
    // },
    handleRemove(item) {
      console.log(item)
        let idx = _.findIndex(this.getterminlistsalesContract, (e) => { 
            return e.id_sc_dtl_invoice == item.termin; 
        }, 0); 
        this.getterminlistsalesContract[idx].nilai_termin = Number(this.getterminlistsalesContract[idx].nilai_termin) + Number(item.value); 
        Event.$emit("updateListTerminSalesContract", { item, action:"remove" });
    },
    handleEditModal(item) {
      this.editData = item;
      let idx = _.findIndex(this.getterminlistsalesContract, (e) => { 
          return e.id_sc_dtl_invoice == item.termin; 
      }, 0); 
      this.getterminlistsalesContract[idx].nilai_termin = Number(this.getterminlistsalesContract[idx].nilai_termin) + Number(item.value);
      this.editModal = !this.editModal;
    },
    handleModalEdit() {
      this.modalForm.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        let idx = _.findIndex(this.getterminlistsalesContract, (e) => { 
            return e.id_sc_dtl_invoice == values.termin; 
        }, 0); 

        
        if ((this.getterminlistsalesContract[idx].nilai_termin-values.value)<0){
          this.displayMessageValue(
            "error-other",
            "Termin Value is not enough!")
        } else {
          values.termin_description = this.getterminlistsalesContract[idx].work_nm;
          values.currency = "IDR";

          let editdata = this.editData
          Event.$emit("updateListTerminSalesContract", { values, editdata, action:"edit" });
          this.getterminlistsalesContract[idx].nilai_termin = 
            this.getterminlistsalesContract[idx].nilai_termin-values.value;
          this.modalForm.resetFields();
          this.editModal = !this.editModal;
        }
      });

      this.modalForm.resetFields();
    },
  },
  mounted() {
    Event.$on("confirmMessageAddDetil", this.handleNewItem);
    Event.$on("confirmMessageDeleteDetil", this.handleRemove);
  },
  beforeDestroy() {
    Event.$off("confirmMessageAddDetil", this.handleNewItem);
    Event.$off("confirmMessageDeleteDetil", this.handleRemove);
  },
};
</script>

<style>
</style>